import axios from 'axios';
import { useEffect, useRef } from 'react';

import { getInjector, getRootScope } from '@/services/angularjs-bridge';

const ItemReviews = ({ primaryKey }: { primaryKey: string }) => {

    const ref = useRef<HTMLDivElement>(null);

    const $angularJsInjector = getInjector();
    const $rootScope = getRootScope($angularJsInjector);
    const $controller = $angularJsInjector.get('$controller');
    const $compile = $angularJsInjector.get('$compile');
    const $templateCache = $angularJsInjector.get('$templateCache');

    useEffect(() => {
        (async function() {
            if (!ref || !ref.current) {
                return;
            }

            const $scope = $rootScope.$new();
            $scope.item = {
                primaryKey__: primaryKey,
            };

            const templateUrl = 'tpl/item-reviews.tpl.html';
            let $template = $templateCache.get(templateUrl);

            if (!$template) {
                $template = (await axios.get(templateUrl)).data;
                $templateCache.put(templateUrl, $template);
            }
            const compileResult = $compile($template)($scope);
            //@ts-ignore
            angular.element(ref.current).append(compileResult);
            // Pass $scope to the controller
            $controller('SupplierItemReviewController', {
                $scope: $scope,
                $element: ref.current,
                //@ts-ignore
                $attrs:angular.element(ref.current).append(compileResult)
            });

            $rootScope.$evalAsync();
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);

    return (
        <div className='tw-absolute tw-bottom-[60px] tw-bg-[#f6f6f6] tw-w-full tw-z-50 tw-px-4 tw-py-1'>
            <div className="tw-h-full tw-flex-1 tw-flex tw-flex-col" ref={ref}></div>
        </div>
    );
};

export { ItemReviews };
